import { Banner, BannerTypes } from "@sunrun/experience-ui-components";

const UtilityBillRequiredForFinalApprovalBanner = ({
  onClickPrimaryAction,
  showIcon,
  className,
}: {
  onClickPrimaryAction?: () => void;
  showIcon: boolean;
  className?: string;
}) => {
  return (
    <Banner
      className={className}
      title="A utility bill is required for final approval with Sunrun."
      bannerType={BannerTypes.InfoLight}
      show={true}
      showClose={false}
      showIcon={showIcon}
      primaryAction={
        onClickPrimaryAction
          ? {
              title: "Upload Utility Bill",
              action: onClickPrimaryAction,
              testId: "upload-utility-bill-button",
            }
          : undefined
      }
    />
  );
};

export { UtilityBillRequiredForFinalApprovalBanner };
